<section class="hero">
  <p class="hero-eyebrow">Ludoteca · Casa del Popolo Bruno Tosarelli · Bologna</p>
  <h1 class="hero-headline">
    Una sera, un tavolo,<br>
    un gioco — e qualcuno<br>
    che te lo spiega.
  </h1>
  <p class="hero-lede">
    Just Play Bologna è una ludoteca di quartiere alla
    <strong>Casa del Popolo Bruno Tosarelli</strong>, in Corticella.
    Ogni settimana, dal lunedì al sabato, apriamo i tavoli a chiunque
    voglia giocare — soci e curiosi, esperti e chi tira un D20 per la
    prima volta.
  </p>
</section>

<hr class="section-rule" aria-hidden="true">

<section class="schedule" aria-labelledby="schedule-h">
  <header class="section-head">
    <h2 id="schedule-h" class="section-title">Quando ci troviamo</h2>
    <p class="section-sub">I nostri appuntamenti settimanali, fissi.</p>
  </header>

  <table class="schedule-table">
    <caption class="sr-only">Orario settimanale degli appuntamenti</caption>
    <thead>
      <tr>
        <th scope="col">Giorno</th>
        <th scope="col">Ora</th>
        <th scope="col">Cosa</th>
        <th scope="col" class="schedule-note-col">Note</th>
      </tr>
    </thead>
    <tbody>
      @for (row of schedule; track row.day + row.time) {
        <tr>
          <td class="schedule-day">{{ row.day }}</td>
          <td class="schedule-time">{{ row.time }}</td>
          <td class="schedule-activity">{{ row.activity }}</td>
          <td class="schedule-note">{{ row.note }}</td>
        </tr>
      }
    </tbody>
  </table>

  <p class="schedule-footnote">
    <em>Non serve prenotare</em>, ma se siete in tanti scriveteci prima
    su <a href="https://t.me/justplaybologna" target="_blank" rel="noopener">Telegram</a>
    o <a href="mailto:info@justplaybo.it">via mail</a> — così prepariamo
    i giochi giusti per voi.
  </p>
</section>

<hr class="section-rule" aria-hidden="true">

<section class="activity" aria-labelledby="activity-h">
  <header class="section-head">
    <h2 id="activity-h" class="section-title">Cosa succede in questi giorni</h2>
    <p class="section-sub">Le novità in bacheca e quello che serve sapere se è la tua prima volta.</p>
  </header>

  <div class="activity-grid">
    <div class="activity-firsttime">
      <h3 class="subhead">La prima volta</h3>

      <p class="activity-firsttime-lede">
        Vieni per la prima volta? Ti diciamo subito quello che serve sapere
        — è meno di quanto immagini.
      </p>

      <p>
        Per giocare con noi devi essere <strong>socio Arci</strong>.
        La tessera costa <strong>10€</strong> (8€ se hai meno di 16 anni),
        è valida da ottobre a settembre, e si fa direttamente in sede la
        sera stessa.
      </p>

      <p>
        Per il resto: non serve prenotare, non serve esperienza, non serve
        portare niente — i giochi te li spieghiamo noi. Tutte e tutti
        benvenuti.
      </p>

      <p class="activity-firsttime-cta">
        <a routerLink="/faq" class="custom-link">Tutte le domande frequenti →</a>
      </p>
    </div>

    <aside class="activity-feed-col" aria-label="Aggiornamenti recenti">
      <h3 class="subhead">In bacheca</h3>

      <div class="activity-frame">
        <iframe
          class="activity-feed"
          title="Bacheca Facebook di Just Play Bologna"
          src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Fjustplaybologna&tabs=timeline&width=400&height=620&small_header=true&adapt_container_width=true&hide_cover=false&show_facepile=true"
          width="400"
          height="620"
          loading="lazy"
          style="border:none;overflow:hidden"
          scrolling="no"
          allow="encrypted-media"></iframe>
      </div>

      <p class="activity-fallback">
        Calendario completo, foto serali e annunci su
        <a href="https://www.facebook.com/justplaybologna" target="_blank" rel="noopener">Facebook</a>,
        <a href="https://www.instagram.com/justplaybologna/" target="_blank" rel="noopener">Instagram</a>
        e <a href="https://t.me/justplaybologna" target="_blank" rel="noopener">Telegram</a>.
      </p>
    </aside>
  </div>
</section>

<hr class="section-rule" aria-hidden="true">

<section class="where" aria-labelledby="where-h">
  <div class="where-text">
    <header class="section-head">
      <h2 id="where-h" class="section-title">Come arrivare</h2>
      <p class="section-sub">Siamo facili da raggiungere.</p>
    </header>

    <address class="where-address">
      <strong>Via Bentini 20</strong><br>
      40128 Bologna (BO)<br>
      <span class="where-place">Casa del Popolo "Bruno Tosarelli" — Circolo Arci Brecht, primo piano</span>
    </address>

    <ul class="transit">
      <li><span class="transit-mode">Bus</span> linee 27A, 97, 98 — fermata <em>Corticella</em></li>
      <li><span class="transit-mode">Treno</span> stazione <em>Bologna Corticella</em></li>
      <li><span class="transit-mode">Auto</span> parcheggio in via Bentini</li>
    </ul>
  </div>

  <div class="where-map">
    <iframe
      title="Mappa: Just Play Bologna in via Bentini 20"
      src="https://maps.google.com/maps?q=44.546179,%2011.3559876&t=&z=18&ie=UTF8&iwloc=&output=embed"
      width="100%"
      height="380"
      loading="lazy"
      referrerpolicy="no-referrer-when-downgrade"></iframe>
  </div>
</section>

<footer class="contacts" aria-labelledby="contacts-h">
  <h2 id="contacts-h" class="contacts-title">Contatti</h2>
  <p>
    <a href="mailto:info@justplaybo.it">info&#64;justplaybo.it</a> ·
    Via Bentini 20, 40128 Bologna (BO)
  </p>
</footer>
